<template>
  <div style="padding: 20px;">
    <h3>饲养信息</h3>
    <br>
    <a-form :form="form" labelAlign="left" >
      <a-row :gutter="24">
        <a-col :span="8">
          <a-form-item label="饲养品种">
            <a-select
              v-if="animalColor !== '有色羽'"
              placeholder="请选择"
              v-decorator="['feedVariety',{rules:[{required: true, message: '请选择饲养品种'}]}]"
            >
              <a-select-option v-for="el in feedVarietyList" :key="el.id" :value="el.name">
                {{ el.name}}
              </a-select-option>
            </a-select>
            <a-input v-else v-decorator="['feedVariety',{rules:[{required: true, message: '请输入饲养品种'}]}]" />
          </a-form-item>
        </a-col>
        <a-col :span="8">
          <a-form-item label="饲料品牌">
            <a-select
              placeholder="请选择"
              v-decorator="['feedBrand',{
                rules:[{required: true, message: '请选择饲料品牌'}],
                initialValue:`新希望`
              }]"
              @change="handleChange"
            >
              <a-select-option v-for="el in feedBrandList" :key="el.varietyDepotCode" :value="el.varietyDepotName">
                {{ el.varietyDepotName}}
              </a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
        <a-col :span="8">
          <a-form-item label="出栏方式">
            <a-radio-group v-decorator="['outType',{rules:[{required: true, message: '请选择出栏方式'}],}]" >
              <a-radio v-for="el in outTypeList" :key="el.id" :value="el.name ">{{ el.name }}</a-radio>
            </a-radio-group>
          </a-form-item>
        </a-col>
        <a-col :span="8">
          <a-form-item label="苗价（元/只）">
            <a-input-number 
              style="width: 100%;"
              placeholder="请输入"
              :min="1"
              :max="10000" 
              :precision="2"
              v-decorator="['seedlingPrice']"
            />
          </a-form-item>
        </a-col>
        <a-col :span="8">
          <a-form-item label="售卖单价（元/斤）">
            <a-input-number 
              style="width: 100%;"
              placeholder="请输入"
              :min="1"
              :max="300" 
              :precision="2"
              v-decorator="['hairyPrice']"
            />
          </a-form-item>
        </a-col>
        <a-col :span="24">
          <a-table 
            :columns="inputFeedInfoRuminateColumns" 
            :data-source="feedInfoList" 
            :pagination="false" 
            :rowKey="(record, index) => { return index }"
          >
            <span slot="dayTitle"><span style="color: red">*</span> 日期</span>
            <span slot="day" slot-scope="text, record ,index">
              <a-date-picker 
                v-model="record.day" 
                valueFormat="YYYY-MM-DD" 
                :disabled-date="index == 0 ? disabledStartDate : disabledEndDate"
              />
            </span>
            <span slot="dayAge" slot-scope="text, record">
              <a-input-number
                placeholder="请输入"
                :min="1"
                :max="300"
                v-model="record.dayAge"
                :precision="2"
                @blur="verificationLegal(record,'dayAge')"
              />
            </span>
            <span slot="weightTitle"><span style="color: red">*</span> 总重（斤）</span>
            <span slot="weight" slot-scope="text, record">
              <a-input-number
                v-if="record.state == '出栏'"
                placeholder="请输入"
                :min="1"
                :max="1000000"
                v-model="record.weight"
                :precision="2"
                @blur="verificationLegal(record,'weight')"
              />
              <span v-else>-</span>
            </span>
            <span slot="numTitle"><span style="color: red">*</span> 数量（只）</span>
            <span slot="num" slot-scope="text, record">
              <a-input-number
                placeholder="请输入"
                :min="1"
                :max="1000000"
                v-model="record.num"
                @blur="verificationLegal(record,'num')"
              />
            </span>
          </a-table>
          <br>
        </a-col>
        <a-col :span="24">
          <div style="margin:10px 0px">饲养阶段</div>
          <a-table 
            :columns="inputFeedStageMeatColumns" 
            :data-source="feedStageList" 
            :pagination="false" 
            :rowKey="(record, index) => { return index }"
          >
            <template slot="stageType" slot-scope="t">{{ stagesObj[t] }}</template>
            <span slot="productNameTitle"><span style="color: red">*</span> 产品名称</span>
            <span slot="productName" slot-scope="text, record, index">
              <a v-if="form.getFieldValue('feedBrand') == '新希望' && !record.productName" 
                @click="handleClick(index)"
              >选择配方</a>
              <a v-else-if="form.getFieldValue('feedBrand') == '新希望' && record.productName" 
                @click="handleClick(index)"
              >{{record.productName}}</a>
              <a-input v-else style="width: 66.66%" placeholder="请输入" v-model="record.productName" :maxLength="50"/>
              <a-button v-if="form.getFieldValue('feedBrand') == '新希望' && record.productName" 
                style="margin-left: 10px" 
                @click="deleteProductName(record)"
              >删除</a-button>
            </span>
            <span slot="feedTerminalPriceTitle"><span style="color: red">*</span> 饲料终端价格（元/kg）</span>
            <span slot="feedTerminalPrice" slot-scope="text, record">
              <a-input-number
                style="width: 66.66%;"
                placeholder="请输入"
                :min="1"
                :max="10000"
                v-model="record.feedTerminalPrice"
                :precision="2"
              />
            </span>
            <span slot="feedCostTitle"><span style="color: red">*</span> 总耗料量（斤）</span>
            <span slot="feedCost" slot-scope="text, record">
              <a-input-number
                style="width: 66.66%;"
                placeholder="请输入"
                :min="1"
                :max="10000000"
                v-model="record.feedCost"
                :precision="2"
              />
            </span>
          </a-table>
          <br>
        </a-col>
      </a-row>
    </a-form>
    <formula-modal 
      ref="formulaModal" 
      :visible="visible" 
      @isShow="isShow" 
      @getSelect="getSelect" 
      :selectFactory="selectFactory"
      :factoryId="factoryId"
    />
  </div>
</template>

<script>
import {inputFeedInfoRuminateColumns,inputFeedStageMeatColumns} from '../Columns'
import { outTypeList,animalTypeList} from './Lists'
import FormulaModal from'./FormulaModal.vue'
import moment from 'moment';

export default {
  props:['selectFactory','factoryId','feedInfoList','poultryLineMeatFeedInfo','poultryLineMeatRaiseInfos','animalType','animalColor'],
  components:{FormulaModal},
  data(){
    return{
      form: this.$form.createForm(this, { name: 'feedInfo' }),
      inputFeedInfoRuminateColumns,
      outTypeList,
      animalTypeList,
      inputFeedStageMeatColumns,
      feedBrandList:[],
      visible: false,
      feedVarietyList:[],
      stagesObj:{
        1: '一',
        2: '二',
        3: '三',
        4: '四',
      },
      feedStageList:[]
    }
  },
  mounted() {
    this.feedStageListGet()
    this.feedBrandGet()
    if(this.$route.query.copyId) this.convert()
    this.form.setFieldsValue(this.poultryLineMeatFeedInfo)
    this.getFeedVarietyList()
  },
  methods:{
    feedStageListGet() {
      this.feedStageList.splice(0,this.feedStageList.length);
      const stages = Object.keys(this.stagesObj)
      stages.forEach(element => {
        this.feedStageList.push({
          nhfFormulaId:'',
          modelCode:'',
          modelName:'',
          stageType:element,
          productName:'',
          feedTerminalPrice:'',
          feedCost:'',
        })
      });
      if(this.poultryLineMeatRaiseInfos.length) {
        for(let a in this.feedStageList){
          for (let b in this.poultryLineMeatRaiseInfos){
            if(this.feedStageList[a].stageType == this.poultryLineMeatRaiseInfos[b].stageType && this.poultryLineMeatRaiseInfos[b].productName){
              this.feedStageList[a].feedCost = this.poultryLineMeatRaiseInfos[b].feedCost
              this.feedStageList[a].feedTerminalPrice = this.poultryLineMeatRaiseInfos[b].feedTerminalPrice
              this.feedStageList[a].nhfFormulaId = this.poultryLineMeatRaiseInfos[b].nhfFormulaId
              this.feedStageList[a].modelCode = this.poultryLineMeatRaiseInfos[b].modelCode
              this.feedStageList[a].modelName = this.poultryLineMeatRaiseInfos[b].modelName
              this.feedStageList[a].productName = this.poultryLineMeatRaiseInfos[b].productName
              continue
            }
          }
        }
      }
    },
    sendData(){
      this.$emit('setFeedInfo', {feedInfoList:this.feedInfoList,feedStageList:this.feedStageList})
    },
    handleChange(){
      this.feedStageList.splice(0,this.feedStageList.length);
      const stages = Object.keys(this.stagesObj)
      stages.forEach(element => {
        this.feedStageList.push({
          nhfFormulaId:'',
          modelCode:'',
          modelName:'',
          stageType:element,
          productName:'',
          feedTerminalPrice:'',
          feedCost:'',
        })
      });
    },
    handleClick(index) {
      this.visible = true
      this.$refs.formulaModal.reset()
      this.$refs.formulaModal.initRecord(index)
    },
    isShow(val){
      this.visible = val
    },
    getSelect(val,index){
      this.feedStageList[index].productName = val[0].formulaName;
      this.feedStageList[index].nhfFormulaId = val[0].id
      this.feedStageList[index].modelName = val[0].modelName;
      this.feedStageList[index].modelCode = val[0].modelCode;
    },
    async feedBrandGet() {
      const res = await this.$http.get("/sat-ruminants/varietydepot/list", {
        params:{type:2, size:-1, labelCode: this.animalColor === '有色羽' ? 'meatTypePoultry' : 'meatTypePoultryWhite'} 
      })
      let { success, data } = res;
      if (success) {
        this.feedBrandList = data.records 
      }
    },
    convert(){
      this.poultryLineMeatFeedInfo.vaccination = this.poultryLineMeatFeedInfo.vaccination ? 1 : 0
      this.feedInfoList[0].day = this.poultryLineMeatFeedInfo.intoDay
      this.feedInfoList[0].num = this.poultryLineMeatFeedInfo.intoNum
      this.feedInfoList[1].day = this.poultryLineMeatFeedInfo.outDay
      this.feedInfoList[1].num = this.poultryLineMeatFeedInfo.outNum
      this.feedInfoList[1].weight = this.poultryLineMeatFeedInfo.outWeight
    },
    disabledStartDate(startValue) {
      const endValue = moment(this.feedInfoList[1].day,'YYYY-MM-DD');
      if (!startValue || !endValue) {
        return false;
      }
      return startValue.valueOf() > endValue.valueOf();
    },
    disabledEndDate(endValue) {
      const startValue = moment(this.feedInfoList[0].day,'YYYY-MM-DD');
      if (!endValue || !startValue) {
        return false;
      }
      return startValue.valueOf() >= endValue.valueOf();
    },
    verificationLegal(record, title) {
      if(this.feedInfoList[0][title] && this.feedInfoList[1][title]){
        if(title == 'num' && record[title] && this.feedInfoList[0][title] < this.feedInfoList[1][title]) {
          this.$message.error('出栏数量不得大于入栏数量，请重新输入！')
          record[title] = ''
        }
      }
    },
    async getFeedVarietyList(){
      let {VarietyDepotCode,LabelCode} = this.animalTypeList.find(
        item => item.name == this.animalType
      )
      let res = await this.$http.get("/sat-ruminants/animalvariety/list", { params:{VarietyDepotCode,LabelCode,size: -1}})
      this.feedVarietyList = res.data.records
    },
    deleteProductName(record){
      record.productName = undefined
      record.nhfFormulaId = ''
      record.modelName = ''
      record.modelCode = ''
    }
  }
}
</script>

<style>

</style>